import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
    map,
    share,
    catchError,
    withLatestFrom,
    exhaustMap,
    filter,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { StocksWalletExchangeCheckoutAction } from './stocks-wallet-exchange-checkout.action';
import { StocksApiService } from '@toro/common/shared/services/stocks/stocks-api.service';

@Injectable()
export class StocksWalletExchangeCheckoutEffects {
    constructor(
        private actions$: Actions<StocksWalletExchangeCheckoutAction>,
        private store$: Store<AppState>,
        private stocksApiService: StocksApiService
    ) { }

    /**
     * Criar uma nova ordem de cliente
     */
    getInvestmentPortfolio$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StocksWalletExchangeCheckoutAction.getInvestmentPortfolio),
            withLatestFrom(this.store$.select((s) => s.authentication)),
            filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
            exhaustMap(([action, auth]) => {
                return this.stocksApiService.get('investment-portfolios/')
                    .pipe(
                        map((result) => {
                            if (result) {
                                return { type: StocksWalletExchangeCheckoutAction.getInvestmentPortfolioSuccess, payload: result.data };
                            }
                            return { type: StocksWalletExchangeCheckoutAction.getInvestmentPortfolioError, payload: result.data };
                        }),
                        catchError((error) => {
                            return of({ type: StocksWalletExchangeCheckoutAction.getInvestmentPortfolioError, payload: error });
                        }),
                    );
            }),
            share())
    );

    getInvestmentPortfolioBySlug$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlug),
            withLatestFrom(this.store$.select((s) => s.authentication)),
            filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
            exhaustMap(([action, auth]) => {
                return this.stocksApiService.get(`investment-portfolios/${action.payload}`)
                    .pipe(
                        map((result) => {
                            if (result) {
                                return { type: StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlugSuccess, payload: result.data };
                            }
                            return { type: StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlugError, payload: result.data };
                        }),
                        catchError((error) => {
                            return of({ type: StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlugError, payload: error });
                        }),
                    );
            }),
            share())
    );

    newInvestmentPortfolioOrder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrder),
            withLatestFrom(this.store$.select((s) => s.authentication)),
            filter(([action, auth]) => auth.currentUser && auth.currentUser.token),
            exhaustMap(([action, auth]) => {
                return this.stocksApiService.post(`investment-portfolios/`, action.payload)
                    .pipe(
                        map((result) => {
                            if (result) {
                                return { type: StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrderSuccess, payload: result.data };
                            }
                            return { type: StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrderError, payload: result.data };
                        }),
                        catchError((error) => {
                            return of({ type: StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrderError, payload: error });
                        }),
                    );
            }),
            share())
    );
}